import axios from "axios";
import { jwtDecode } from "jwt-decode";
import config from "./Config";
import { ROOT_PAGE } from "./constants/routerConstants";
import globalRouter from "./utils/globalRouter";

export const tiInstance = axios.create({
  baseURL: config.tiUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const crcInstance = axios.create({
  baseURL: config.crcUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const refInstance = axios.create({
  baseURL: config.refProdUrl,
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export const authInstance = axios.create({
  baseURL: config.authUrl,
});

const configuration = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      localStorage.removeItem("token");
      globalRouter.navigate(ROOT_PAGE);
    } else {
      const header = "Bearer " + token;
      config.headers.Authorization = header;
    }
  } else {
    localStorage.removeItem("token");
    globalRouter.navigate(ROOT_PAGE);
  }

  return config;
};

tiInstance.interceptors.request.use((config) => configuration(config));
refInstance.interceptors.request.use((config) => configuration(config));
crcInstance.interceptors.request.use((config) => configuration(config));
